import { v1 as uuidv1 } from 'uuid'

// @param { planId: string; value: number; currency?: string; coupon?: string } params
const trackGAPurchase = (params) => {
  const { planId, value, currency, coupon, discount } = params
  function capitalize (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const transactionId = `${planId}-${uuidv1()}`
  const planName = planId.split('_').map(word => capitalize(word)).join(' ')

  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: transactionId,
        value,
        currency: currency || 'USD',
        coupon: coupon || undefined,
        items: [
          {
            item_id: planId,
            item_name: planName,
            price: value,
            quantity: 1,
            discount: discount || undefined
          }
        ]
      }
    })
  } catch (e) {
    console.log('GA error', e)
  }
}

export default {
  trackGAPurchase
}